import { render, staticRenderFns } from "./BillPrintIframe.vue?vue&type=template&id=07ca18dc&scoped=true"
import script from "./BillPrintIframe.vue?vue&type=script&lang=js"
export * from "./BillPrintIframe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ca18dc",
  null
  
)

export default component.exports